import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService, authUserType, reRgType } from 'app/services/auth.service';

@Component({ templateUrl: './support.component.html' })

export class SupportComponent implements OnInit {
  private auth = inject(AuthenticationService);

  public user?: authUserType;
  public reRg?: reRgType;

  ngOnInit(): void {
    this.user = this.auth.getUser();
    this.reRg = this.auth.getCurrentReRg();
  }
}
